import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const memberWorkApi = {
    //獲取所有產品類別
    "queryCompanyDefaultMemberWork": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/queryCompanyDefaultMemberWork`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode:null
            }
        }
    },
    //修改公司名片聯繫方式
    "updateMemberWorkByInputBy": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}work/updateMemberWorkByInputBy`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {companycode:null,inputby:null}
        }
    },

}

export default memberWorkApi